import { lazy } from 'react';

const Glossary = lazy(() => import(/* webpackChunkName: "glossary" */ './Container'));

export default Glossary;
